import {Component, ElementRef, forwardRef, HostListener, Input} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUINumericPillComponent),
            multi: true
        }
    ],
    selector: "fui-numeric-pill",
    styleUrls: ["./numeric-pill.component.scss"],
    templateUrl: "./numeric-pill.component.html"
})
export class FUINumericPillComponent extends FUIAbstractPill {
    private _displayedValue: string;

    @Input() decimals: number;

    /**
     * Indicates if the pill can be removed
     */
    @Input() public removable: boolean;

    constructor(public elementRef: ElementRef) {
        super();
    }

    get displayedValue(): string {
        return this._displayedValue;
    }

    set displayedValue(displayedValue: string) {
        if (this.isValid(displayedValue)) {
            this._displayedValue = displayedValue;
        } else {
            const selectionStart = this.input.nativeElement.selectionStart - 1;
            const selectionEnd = this.input.nativeElement.selectionEnd - 1;
            this.input.nativeElement.value = this._displayedValue || "";
            this.input.nativeElement.selectionStart = selectionStart;
            this.input.nativeElement.selectionEnd = selectionEnd;
        }
        super.value = !this._displayedValue ? undefined : this._displayedValue === "." ? "0" : Number(this._displayedValue);
    }

    private setValidDisplayValue(value: string): void {
        this._displayedValue = value === "." ? "0" : value == undefined || this.decimals === undefined ? value : Number(value).toFixed(this.decimals);
    }

    private isValid(value: string): boolean {
        if (!value || value === ".") {
            return true;
        }
        if (isNaN(+value)) {
            return false;
        }
        if (this.decimals === undefined) {
            return true;
        }
        const i = value.indexOf(".");
        return i < 0 || i >= value.length - 3;
    }

    override set value(value: any) {
        super.value = value;
        this.setValidDisplayValue(value);
    }

    override writeValue(value: any): void {
        super.writeValue(value);
        this.setValidDisplayValue(value);
    }

    public override onBlur(event?: any): void {
        super.onBlur();
        this.setValidDisplayValue(super.value);
    }
}
